<template>
  <component :is="layout" v-bind="properties">
    <slot />
  </component>
</template>

<script lang="js">
import EmptyLayout from "@/layouts/EmptyLayout";
import AuthLayout from "@/layouts/AuthLayout";
import MainLayout from "@/layouts/MainLayout";
import LaunchDeviceLayout from "@/layouts/LaunchDeviceLayout";

export default {
  name: "Layout",
  components: {
    AuthLayout,
    MainLayout,
    LaunchDeviceLayout,
  },
  computed: {
    layout() {
      return this.$route.meta.layout || EmptyLayout;
    },
    properties() {
      if (this.$route.meta.layout == "AuthLayout") {
        return { isLogin: this.$route.meta.isLogin || false };
      }
      return null;
    },
  },
};
</script>
